import { ADD_CALENDAR_START_MONTH } from './../../action-types/bookproperties';

export const STATE_KEY = 'calendarStartMonth';

export const calendarStartMonth = (state = 0, action) => {
  switch (action.type) {
    case ADD_CALENDAR_START_MONTH: {
      return action.month;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/bookproperties/calendarMonth.js